export const safeExcelValue = (value) => {
    if (value === null || value === undefined) {
        return ''
    }

    // Number > 15 digits
    if (typeof value === 'number' && value > Number.MAX_SAFE_INTEGER) {
        return `="${value.toString()}"`
    }

    // Number string with 15+ digits
    if (typeof value === 'string' && /^\d{15,}$/.test(value)) {
        return `="${value}"`
    }

    return value
}

export const withUtf8Bom = (csvString) => {
    return '\uFEFF' + csvString
}

export const csvToBlob = (csvString) => {
    return new Blob([csvString], { type: 'text/csv;charset=utf-8;' })
}

export const triggerFileDownload = (blob, fileName) => {
    const link = document.createElement('a')
    const url = URL.createObjectURL(blob)

    link.href = url
    link.download = fileName
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)

    URL.revokeObjectURL(url)
}